import { render, staticRenderFns } from "./AssetStates.vue?vue&type=template&id=5275c927&scoped=true"
import script from "./AssetStates.vue?vue&type=script&lang=js"
export * from "./AssetStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275c927",
  null
  
)

export default component.exports